const getTitle = item => {
	switch (item.sys.contentType.sys.id) {
		case "atomLink":
			return item.fields?.linkText;
		default:
			return item.fields?.title;
	}
};

const getDescription = item => {
	switch (item.sys.contentType.sys.id) {
		case "pageWebinar":
			return item.fields?.lead;
		case "pageIntegration":
			return item.fields?.subtitle;
		case "atomLink":
			return item.fields?.description;
		default:
			return item.fields?.metaDescription;
	}
};

const getImage = item => {
	switch (item.sys.contentType.sys.id) {
		case "pageIntegration":
			return item.fields?.logo?.fields?.file?.url;
		default:
			return item.fields?.thumbnail?.fields?.file?.url;
	}
};

const getType = item => {
	switch (item.sys.contentType.sys.id) {
		case "pageWebinar":
			return item.fields?.eventType;
		case "pageIntegration":
			return item.fields?.integrationTag;
		case "atomLink":
			return item.fields?.linkTag;
		default:
			return "";
	}
};

const getExternalUrl = item => {
	switch (item.sys.contentType.sys.id) {
		case "atomLink":
			return item.fields?.linkUrl;
		default:
			return item.fields?.externalUrl;
	}
};

export const mapItems = items => {
	return items.map(item => {
		return {
			sys_id: item.sys.id,
			sys_type: item.sys.contentType.sys.id,
			title: getTitle(item),
			description: getDescription(item),
			teaser: item.fields?.teaser || "",
			image: getImage(item),
			slug: item.fields?.slug || "",
			url: item.fields?.linkUrl || "",
			externalUrl: getExternalUrl(item) || "",
			type: getType(item),
			lead: item.fields?.lead || item.fields?.leadIn || "",
			thumbnail: item.fields?.thumbnail?.fields?.file?.url,
			articleType: item.fields?.articleType,
		};
	});
};

const mapFeaturedBlock = data => {
	const { items } = data;

	return items.map(item => {
		return {
			sys_id: item.sys.id,
			sys_type: item.sys.contentType.sys.id,
			id: item.fields.id,
			name: item.fields.name,
			blockOrder: item.fields.blockOrder,
			items: mapItems(item.fields.contentReference),
		};
	});
};

export default mapFeaturedBlock;
